import http from "infra/http";
import { useMutation } from "react-query";
import {
  ImportarPlanilhaPrevisaoOrcamentariaRequest,
  ImportarPlanilhaPrevisaoOrcamentariaItem,
} from "../typings";
import { AxiosError } from "axios";
import { ImportarPlanilhaError } from "core/resources/types/shared";

function useImportarPlanilhaPrevisaoOrcamentaria(id: string) {
  return useMutation<
    {
      errors: ImportarPlanilhaError<ImportarPlanilhaPrevisaoOrcamentariaItem>[];
      id: string;
    },
    AxiosError,
    ImportarPlanilhaPrevisaoOrcamentariaRequest
  >(
    (data: ImportarPlanilhaPrevisaoOrcamentariaRequest) => {
      return http.post(`/v1/previsao-orcamentaria/${id}/importacao`, data);
    },

    { retry: false }
  );
}

export default useImportarPlanilhaPrevisaoOrcamentaria;
